'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconAliases = require('icons/iconAliases');

var _iconAliases2 = _interopRequireDefault(_iconAliases);

var _reactUtils = require('react-utils');

var _Style = require('../core/Style');

var _IconConstants = require('./IconConstants');

var _iconName = require('../utils/propTypes/iconName');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minSize = 9; // See HubSpot/UIComponents#4436

var UIIcon = _react2.default.createClass({
  displayName: 'UIIcon',

  mixins: [_reactAddonsPureRenderMixin2.default],
  propTypes: {
    color: _react.PropTypes.string,
    className: _react.PropTypes.string,
    name: (0, _iconName.getIconNamePropType)().isRequired,
    size: _react.PropTypes.oneOfType([_react.PropTypes.oneOf((0, _underscore.keys)(_IconConstants.ICON_SIZES)), _react.PropTypes.number]),
    style: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      renderedIconSize: null
    };
  },
  componentDidMount: function componentDidMount() {
    setTimeout(this.updateRenderedIconSize, 0);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (!(0, _underscore.isEqual)(prevProps, this.props)) {
      this.updateRenderedIconSize();
    }
  },
  updateRenderedIconSize: function updateRenderedIconSize() {
    if (!this._span) {
      return;
    }
    if (this.props.size) {
      return;
    }
    var styles = window.getComputedStyle(this._span, null);
    if (styles == null) {
      // See #4208
      return;
    }
    var renderedIconSize = parseInt(styles.fontSize, 10);
    if (renderedIconSize !== this.state.renderedIconSize) {
      this.setState({
        renderedIconSize: renderedIconSize
      });
      if (renderedIconSize > 64 || this._span.offsetHeight > 64) {
        _devLogger2.default.warn({
          message: 'Icon "' + this.props.name + '" is too large, consider using an illustration instead.',
          key: 'UIIcon too large'
        });
      }
    }
  },
  getIconClassName: function getIconClassName(size) {
    size = size || this.state.renderedIconSize;
    if (size === null) {
      size = 'high';
    } else if (_IconConstants.ICON_SIZES[size]) {
      size = _IconConstants.ICON_SIZES[size] <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
    } else if (typeof size === 'number') {
      size = size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
    }
    return 'private-icon__' + size;
  },
  getClassName: function getClassName(size, _ref) {
    var className = _ref.className;

    return (0, _reactUtils.classNames)('private-icon', this.getIconClassName(size), className);
  },
  computedFontSize: function computedFontSize(size) {
    if (!size) {
      return null;
    }

    if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
      return (0, _Style.remCalc)(_IconConstants.ICON_SIZES[size]);
    }

    if (size < minSize) {
      _devLogger2.default.warn({
        message: 'UIIcon: size={' + size + '} is too small. The minimum is size={' + minSize + '}.',
        key: 'UIIcon too small'
      });
      return (0, _Style.remCalc)(minSize);
    }

    return (0, _Style.remCalc)(size);
  },
  spanRefCallback: function spanRefCallback(ref) {
    this._span = ref;
  },
  render: function render() {
    var _props = this.props,
        color = _props.color,
        className = _props.className,
        name = _props.name,
        style = _props.style,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['color', 'className', 'name', 'style', 'size']);

    var computedName = _iconAliases2.default[name] || name;
    return _react2.default.createElement(
      'span',
      _extends({}, rest, {
        'aria-hidden': true,
        className: this.getClassName(size, { className: className }),
        ref: this.spanRefCallback,
        style: _extends({
          color: color
        }, style, {
          fontSize: this.computedFontSize(size)
        })
      }),
      computedName
    );
  }
});

exports.default = UIIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/icon/UIIcon.js
// module id = 8
// module chunks = 0